/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DimensionDefinition extends models.BaseDefinition {
    getFixupPrototypeFunction() { return DimensionDefinition.fixupPrototype; }

    static newInstance(model: Partial<DimensionDefinition>): DimensionDefinition {
        let obj = Object.assign(new DimensionDefinition(), model);
        DimensionDefinition.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DimensionDefinition>): DimensionDefinition {
        if (!model) return null;
        return DimensionDefinition.newInstance(<DimensionDefinition> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DimensionDefinition) {
        if (!obj) return;

        models.DimensionDefinition.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DimensionDefinition): boolean {
        if (models.BaseDefinition.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, DimensionDefinition.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Owner of the dimension definition
     */
    owner: string;

    /**
     * States if the Dimension Definition is active or not
     */
    is_active: boolean;

    /**
     * Name of the Dimension Definition
     */
    name: string;

    /**
     * Description of Dimension Definition
     */
    description: string;

    /**
     * Master account ID
     */
    master_account_id: string;

    /**
     * Source of  Dimension Definition
     */
    source: models.DimensionSource;

    /**
     * Type of  Dimension Definition
     */
    dimension_type: models.DimensionType;

    /**
     * Type of  Dimension Definition Template Used
     */
    dimension_template_type: models.DimensionTemplateType;

    /**
     * If True, Cost Anomaly Detection will be enabled for all grouping rules under this Dimension
     */
    is_cost_anomaly_detection_enabled: boolean = false;

}
